import type { Deal, DealType } from "~/models/Deal";
import type { PastDealList } from "~/models/PastDeal";
import { hasAnyPastDeals, hasSameDealTypePastDeals } from "~/models/PastDeal";
import { canUseAiOwnerExplanationSuggestionStatus } from "~/models/Status";

export type OwnerExplanationSuggestion = {
	status: "processing" | "succeeded" | "failed";
	suggestions:
		| {
				content: string;
				order: number;
				title: string;
		  }[]
		| null;
};

export const canUseAiOwnerExplanationSuggestionByDeal = (deal: Deal): boolean =>
	deal.dealType !== "other" &&
	canUseAiOwnerExplanationSuggestionStatus(deal.statusId);

export const hasUsablePastDealsForAiOwnerExplanationSuggestion = (
	pastDeals: PastDealList | null,
	dealType: DealType
): boolean =>
	hasAnyPastDeals(pastDeals) && hasSameDealTypePastDeals(pastDeals, dealType);
